import { h, type FunctionalComponent } from 'vue'

/**
 * Functional component shim to resolve map-x-icon web component warnings
 *
 * Pre-compiled Map-X components use `<map-x-icon>`, a web component, in templates which triggers
 * Vue's "Failed to resolve component: map-x-icon" warn. This shim wraps & delegates to the web component
 * when registered after app initialization.
 *
 * @example
 *
 * ```ts
 * import mapXIconShim from '@/components/map-x/map-x-icon-shim'
 *
 * // app = createApp(...) then...
 *
 * // Register map-x-icon under the same tag name the compiled code is looking for:
 * // eslint-disable-next-line vue/component-definition-name-casing
 * app.component('map-x-icon', mapXIconShim)
 *
 * // app.mount(...)
 * ```
 */
const mapXIconShim: FunctionalComponent = (_, { attrs, slots }) => {
  return h('map-x-icon', attrs, slots.default?.())
}

mapXIconShim.displayName = 'MapXIconShim'
mapXIconShim.inheritAttrs = false

export default mapXIconShim
